import React from 'react';
import PropTypes from 'prop-types';
import Bar from './Bar';
import Round from './Round';

/**
 * @deprecated Please use ProgressLine or ProgressCircle from @fiverr-private/feedback instead.
 */
const ProgressBar = ({
    round,
    size,
    ...rest
}) => {
    if (round) { return <Round size={size} {...rest}/>;}

    return <Bar {...rest}/>;
};

ProgressBar.displayName = 'ProgressBar';

ProgressBar.propTypes = {
    /**
     * The current progress percentage.
     */
    percent: PropTypes.number.isRequired,
    /**
     * Render a rounded progressbar instead of a straight one.
     */
    round: PropTypes.bool,
    /**
     * Any node that can be rendered.
     * Relevant only when `round`.
     */
    children: PropTypes.node,
    /**
     * Custom classes you wish to pass to the component.
     */
    className: PropTypes.string,
    /**
     * Custom classes you wish to pass to the progress layer.
     */
    progressClassName: PropTypes.string,
    /**
     * Custom classes you wish to pass to the threshold.
     */
    thresholdClassName: PropTypes.string,
    /**
     * Custom classes you wish to pass to the limits text.
     */
    limitsClassName: PropTypes.string,
    /**
     * Custom classes you wish to pass to the background layer.
     */
    backgroundClassName: PropTypes.string,
    /**
     * The bar's stroke width, in pixels.
     */
    strokeWidth: PropTypes.number,
    /**
     * A custom fill color.
     * Should be compatible with the css `color` rule.
     */
    fill: PropTypes.string,
    /**
     * Display a threshold at a certain perventage.
     * Relevant only when not `round`
     */
    threshold: PropTypes.number,
    /**
     * Display a label above the current progress.
     * Relevant only when not `round`.
     */
    label: PropTypes.string,
    /**
     * Displays the minimum and maximum of the progressbar.
     */
    limits: PropTypes.shape({
        min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        max: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    /**
     * The component's size, in pixels.
     * Relevant only when `round`.
     */
    size: PropTypes.number
};

ProgressBar.defaultProps = {
    round: false,
    size: 30
};

export default ProgressBar;
